import sectionStyles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, Form, Input, Row, Select } from "antd";
import { useFormEditable } from "../../hooks/useFormEditable";
import { HighValuePurchaseRequisitionFormValue } from "../../type";
import { useTranslation } from "react-i18next";

export function FixedAssetInfoFormFields() {
  const { t } = useTranslation("purchaseRequestManagement");
  const { t: tCommon } = useTranslation("common");

  const form = Form.useFormInstance<HighValuePurchaseRequisitionFormValue>();

  const { isCreateFixedAssetsNoFormFieldsDisabled } = useFormEditable();
  const shouldCreatedFixedAssetsNo = Form.useWatch("isFixedAssets", form) === 1;

  return (
    <div className={sectionStyles.formSection}>
      <ModalSectionHeader title={t("固定资产信息")} />

      <div className={sectionStyles.sectionBody}>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<HighValuePurchaseRequisitionFormValue>
              label={t("是否创建固定资产编号")}
              name="isFixedAssets"
              rules={[
                {
                  required: true,
                  message: t("请选择是否创建固定资产编号"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={[
                  {
                    label: tCommon("是"),
                    value: 1,
                  },
                  {
                    label: tCommon("否"),
                    value: 0,
                  },
                ]}
                disabled={isCreateFixedAssetsNoFormFieldsDisabled}
                onChange={(value) => {
                  if (value === 0) {
                    form.setFieldsValue({
                      fixedAssetsNo: "",
                    });
                  }
                }}
              />
            </Form.Item>
          </Col>
          {shouldCreatedFixedAssetsNo && (
            <Col span={8}>
              <Form.Item<HighValuePurchaseRequisitionFormValue>
                label={t("固定资产编号")}
                name="fixedAssetsNo"
                rules={[
                  {
                    required: true,
                    message: t("请输入固定资产编号"),
                  },
                ]}
              >
                <Input
                  disabled={isCreateFixedAssetsNoFormFieldsDisabled}
                  placeholder={t("请输入")}
                  maxLength={50}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
}
